import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import DesktopMonthPicker from 'redesign/components/molecules/desktop-month-picker'
import MobileMonthPicker from 'redesign/components/molecules/mobile-month-picker'
import type { MonthPickerProps } from './types'

const MonthPicker = (props: MonthPickerProps) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return isSmallScreen ? <MobileMonthPicker {...props} /> : <DesktopMonthPicker {...props} />
}

export default MonthPicker
